import React, { useEffect, useState } from "react";
import authenticatedFetcher from "../../services/fetcher";

export const SarDataRecoveryForm = (props) => {
  const { userPk } = props;
  const [userData, setUserData] = useState();

  const resetFields = () => {
    const documents = document.querySelectorAll("input[readonly]");
    for (let doc of documents) {
      doc.value = "";
    }
  };
  const fetchPersonData = () => {
    authenticatedFetcher({
      path: `/persons/${userPk}/sar-person-data/`,
    }).then((response) => {
      resetFields();
      setUserData(response);
    });
  };
  useEffect(() => {
    if (userPk) fetchPersonData();
    if (!userPk) resetFields();
  }, [userPk]);
  return (
    <form>
      <div className="form-row">
        <div className="col-md-3 form-group">
          <input
            tabIndex={1}
            type="text"
            className="form-control BasicInput"
            id="nombre"
            value={userData?.first_name}
            readOnly
            autoComplete="off"
          />
        </div>
        <div className="col-md-3 form-group">
          <input
            tabIndex={2}
            type="text"
            className="form-control BasicInput"
            id="apellido"
            value={userData?.last_name}
            readOnly
            autoComplete="off"
          />
        </div>
        <div className="col-md-3 form-group">
          <input
            tabIndex={3}
            type="text"
            className="form-control BasicInput"
            id="segundo-apellido"
            value={userData?.second_last_name}
            readOnly
            autoComplete="off"
          />
        </div>
        <div className="col-md-3 form-group">
          <input
            tabIndex={4}
            type="text"
            className="form-control BasicInput"
            id="entidad"
            value={userData?.enterprise_name}
            readOnly
            autoComplete="off"
          />
        </div>
      </div>
      <div className="form-row">
        <div className="col-md-3 form-group">
          <label htmlFor="nif">NIF</label>
          <input
            tabIndex={5}
            type="text"
            className="form-control BasicInput"
            id="nif"
            value={userData?.identity_document}
            readOnly
            autoComplete="off"
          />
        </div>
        <div className="col-md-3 form-group">
          <label htmlFor="nombre">Tel Prof 1</label>
          <input
            tabIndex={6}
            type="text"
            className="form-control BasicInput"
            id="nombre"
            value={userData?.professional_phone}
            readOnly
            autoComplete="off"
          />
        </div>
        <div className="col-md-3 form-group">
          <label htmlFor="apellido">Tel Cont. 1</label>
          <input
            tabIndex={7}
            type="text"
            className="form-control BasicInput"
            id="apellido"
            value={userData?.contact_phone}
            readOnly
            autoComplete="off"
          />
        </div>
        <div className="col-md-3 form-group">
          <label htmlFor="entidad">Correo</label>
          <input
            tabIndex={8}
            type="text"
            className="form-control BasicInput"
            id="entidad"
            value={userData?.email}
            readOnly
            autoComplete="off"
          />
        </div>
      </div>
      <div className="form-row">
        <div className="col-md-2 form-group">
          <label htmlFor="telefono1">Tel Prof 2</label>
          <input
            tabIndex={9}
            type="text"
            className="form-control BasicInput"
            id="telefono1"
            value={userData?.professional_phone_secondary}
            readOnly
            autoComplete="off"
          />
        </div>
        <div className="col-md-2 form-group">
          <label htmlFor="telefono2">Tel Cont. 2</label>
          <input
            tabIndex={10}
            type="text"
            className="form-control BasicInput"
            id="telefono2"
            value={userData?.contact_phone_secondary}
            readOnly
            autoComplete="off"
          />
        </div>
      </div>
      <div className="form-row justify-content-between">
        <div className="col-md-2 form-group">
          <label htmlFor="titulo">Num. Miembro</label>
          <input
            tabIndex={11}
            type="text"
            className="form-control BasicInput"
            id="titulo"
            value={userData?.mifid_data?.code}
            readOnly
            style={{
              background: userData?.mifid_data?.is_drop
                ? "red"
                : userData?.mifid_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={17}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={userData?.lcci_data?.code}
            readOnly
            style={{
              background: userData?.lcci_data?.is_drop
                ? "red"
                : userData?.lcci_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={23}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={userData?.esg_data?.code}
            readOnly
            style={{
              background: userData?.esg_data?.is_drop
                ? "red"
                : userData?.esg_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={29}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={userData?.insurance_data?.code}
            readOnly
            style={{
              background: userData?.insurance_data?.is_drop
                ? "red"
                : userData?.insurance_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
        </div>
        <div className="col-md-3 form-group">
          <label htmlFor="fechaInicio">Certificado</label>
          <input
            tabIndex={12}
            type="text"
            className="form-control BasicInput"
            id="fechaInicio"
            value={userData?.mifid_data?.contact_level_name}
            readOnly
            style={{
              background: userData?.mifid_data?.is_drop
                ? "red"
                : userData?.mifid_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={18}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={userData?.lcci_data?.contact_level_name}
            readOnly
            style={{
              background: userData?.lcci_data?.is_drop
                ? "red"
                : userData?.lcci_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={24}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={userData?.esg_data?.contact_level_name}
            readOnly
            style={{
              background: userData?.esg_data?.is_drop
                ? "red"
                : userData?.esg_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={30}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={userData?.insurance_data?.contact_level_name}
            readOnly
            style={{
              background: userData?.insurance_data?.is_drop
                ? "red"
                : userData?.insurance_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
        </div>
        <div className="col-md-2 form-group">
          <label htmlFor="horas">Fecha</label>
          <input
            tabIndex={13}
            type="text"
            className="form-control BasicInput"
            id="horas"
            value={userData?.mifid_data?.group_name}
            readOnly
            style={{
              background: userData?.mifid_data?.is_drop
                ? "red"
                : userData?.mifid_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={19}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={userData?.lcci_data?.group_name}
            readOnly
            style={{
              background: userData?.lcci_data?.is_drop
                ? "red"
                : userData?.lcci_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={25}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={userData?.esg_data?.group_name}
            readOnly
            style={{
              background: userData?.esg_data?.is_drop
                ? "red"
                : userData?.esg_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={31}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={userData?.insurance_data?.group_name}
            readOnly
            style={{
              background: userData?.insurance_data?.is_drop
                ? "red"
                : userData?.insurance_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
        </div>
        <div className="col-md-1 form-group">
          <label
            style={{
              fontSize: "9px",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
            htmlFor="realizadas"
          >
            Horas Requeridas
          </label>
          <input
            tabIndex={14}
            type="text"
            className="form-control BasicInput"
            id="realizadas"
            value={userData?.mifid_data?.hours_to_perform}
            readOnly
            style={{
              background: userData?.mifid_data?.is_drop
                ? "red"
                : userData?.mifid_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={20}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={userData?.lcci_data?.hours_to_perform}
            readOnly
            style={{
              background: userData?.lcci_data?.is_drop
                ? "red"
                : userData?.lcci_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={26}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={userData?.esg_data?.hours_to_perform}
            readOnly
            style={{
              background: userData?.esg_data?.is_drop
                ? "red"
                : userData?.esg_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={32}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={userData?.insurance_data?.hours_to_perform}
            readOnly
            style={{
              background: userData?.insurance_data?.is_drop
                ? "red"
                : userData?.insurance_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
        </div>
        <div className="col-md-1 form-group">
          <label
            style={{
              fontSize: "9px",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
            htmlFor="colegiado2"
          >
            Horas Realizadas
          </label>
          <input
            tabIndex={15}
            type="text"
            className="form-control BasicInput"
            id="colegiado2"
            value={userData?.mifid_data?.hours_performed}
            readOnly
            style={{
              background: userData?.mifid_data?.is_drop
                ? "red"
                : userData?.mifid_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={21}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={userData?.lcci_data?.hours_performed}
            readOnly
            style={{
              background: userData?.lcci_data?.is_drop
                ? "red"
                : userData?.lcci_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={27}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={userData?.esg_data?.hours_performed}
            readOnly
            style={{
              background: userData?.esg_data?.is_drop
                ? "red"
                : userData?.esg_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={33}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={userData?.insurance_data?.hours_performed}
            readOnly
            style={{
              background: userData?.insurance_data?.is_drop
                ? "red"
                : userData?.insurance_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
        </div>
        <div className="col-md-1 form-group">
          <label
            style={{
              fontSize: "9px",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
            htmlFor="colegiado2"
          >
            Código ético web
          </label>
          <input
            tabIndex={16}
            type="text"
            className="form-control BasicInput"
            id="colegiado2"
            value={
              userData?.mifid_data
                ? userData?.mifid_data?.signed
                  ? "Si"
                  : "No"
                : ""
            }
            readOnly
            style={{
              background: userData?.mifid_data?.is_drop
                ? "red"
                : userData?.mifid_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={22}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={
              userData?.lcci_data
                ? userData?.lcci_data?.signed
                  ? "Si"
                  : "No"
                : ""
            }
            readOnly
            style={{
              background: userData?.lcci_data?.is_drop
                ? "red"
                : userData?.lcci_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={28}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={
              userData?.esg_data
                ? userData?.esg_data?.signed
                  ? "Si"
                  : "No"
                : ""
            }
            readOnly
            style={{
              background: userData?.esg_data?.is_drop
                ? "red"
                : userData?.esg_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
          <input
            tabIndex={34}
            type="text"
            className="form-control BasicInput mt-2"
            id="titulo"
            value={
              userData?.insurance_data
                ? userData?.insurance_data?.signed
                  ? "Si"
                  : "No"
                : ""
            }
            readOnly
            style={{
              background: userData?.insurance_data?.is_drop
                ? "red"
                : userData?.insurance_data?.is_warning
                  ? "yellow"
                  : undefined,
            }}
            autoComplete="off"
          />
        </div>
      </div>
    </form>
  );
};
